module.exports = __webpack_public_path__ + "static/media/3.8a64a07e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Dots/3.svg
// module id = 307
// module chunks = 0